export const agenda = {
  agendaDuration: 'durata',
  agendaCurtainCopy: 'Copia link',
  agendaCurtainFlag: 'Segnala contenuto',
  agendaCurtainFlagSent: 'Contenuto segnalato',
  agendaLinkCopied: 'Link copiato!',
  agendaStartsAt: 'Inizia alle ',
  agendaEndsAt: 'Termina alle ',
  agendaSpeakers: 'Relatori',
  agendaSeeAllSpeakers: 'Visualizza tutto',
  agendaAddToSchedule: 'Aggiungi al mio programma',
  agendaRemoveFromSchedule: 'Rimuovi dal mio programma',
  agendaAddedToSchedule: 'Aggiunto al mio programma!',
  agendaRemovedFromSchedule: 'Rimosso dal mio programma!',
  agendaCalendar: 'Calendario',
  agendaAddToCalendar: 'Aggiungi al calendario del sistema?',
  agendaCalendarSkip: 'Salta',
  agendaCalendarAdd: 'Aggiungi',
  agendaNow: 'ORA',
  agendaModerators: 'Moderatori',

  QnATitle: 'Domande e risposte',
  askASpeaker: 'Fai una domanda al relatore',
  askAQuestion: 'Fai una domanda',
  askQuestionPlaceholder: 'Inserisci qui la tua domanda',
  cancel: 'Annulla',
  ask: 'Invia',
  deleteConfirmation: 'Vuoi eliminare questa domanda?',
  questionDeleted: 'Domanda eliminata con successo!',
  rateSession: 'Valuta questa sessione'
}
